import LibraryShellPageView from "../library/LibraryShellPageView";
import ti18n from "i18n!nls/MyLibraryi18n";

const SharedWithMePageView = LibraryShellPageView.extend({
  pageName: "Shared With Me",

  initialize: function (options) {
    LibraryShellPageView.prototype.initialize.call(this, {
      ...options,
      shellConfig: {
        pageId: "sharedWithMe",
        pageTitle: window.getI18n(ti18n, "SHARED_WITH_ME"),
        section: "library",
        pageMode: "sharedWithMe",
        showActionButton: false,
      },
    });
  },
});

export default SharedWithMePageView;
